export const colours = {
  images: {
    default: 'hotpink',
    active: 'blue',
    hover: 'red',
    cluster: 'hotpink',
  },
  white: {
    lightmode: '#f8f8f8',
    darkmode: '#111111',
  },
  geojson: {
    active: 'blue',
  },
};

export { aciToHex, aciToRgb, mapBoxCadColors } from './cad';
export { downloadStringAsFile } from './file';
export { groupImagesByPosition, groupImagesByPosition2, parseCameraConfig, parseIprj, parseIprjList } from './iprj';
export type {
  CameraCalibrationConfig,
  CameraConfig,
  ImageListConfig,
  ImageListEntry,
  IprjConfig,
  PositionGroup,
} from './iprj';
export { project, reprojectGeoJSON, traverseAndProject } from './map';
export { parseOgrStyle, toDreiTextProps, toMapbox, toThreeMeshBasicParams } from './style';
export { computeMapOrigin } from './three';
